import { render, staticRenderFns } from "./final-report.vue?vue&type=template&id=1f95813a&scoped=true"
import script from "./final-report.vue?vue&type=script&lang=js"
export * from "./final-report.vue?vue&type=script&lang=js"
import style0 from "./final-report.vue?vue&type=style&index=0&id=1f95813a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f95813a",
  null
  
)

export default component.exports